import { createClient } from '@supabase/supabase-js';

// Replace these with your Supabase credentials
const supabaseUrl = 'https://eiojxadvwbyjehiowyhd.supabase.co'; // Your Project URL
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVpb2p4YWR2d2J5amVoaW93eWhkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIyNDUzNTksImV4cCI6MjA1NzgyMTM1OX0.hjUkpp3Z-esiBsVET2LTnnnz5FnWkWkk3MwXuTE9wwk'; // Your anon key

export const supabase = createClient(supabaseUrl, supabaseKey);